import * as types from "./types";
import {
     getPerformanceRecordAxios,
     postPerformanceRecordAxios,
     putPerformanceRecordAxios,
     deletePerformanceRecordAxios,
} from "./services";


export async function getPerformanceRecordListAction({ commit }) {
    commit(types.LOADING_PERFORMANCE_RECORD, true);
    try {
        const { data } = await getPerformanceRecordAxios();
        commit(types.GET_PERFORMANCE_RECORD_LIST, data.result.data);
        console.log("Performancerecords", data.result.data);
    }
    catch (e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_PERFORMANCE_RECORD, false);
    }

    
}
export async function addPerformanceRecordAction({ commit }, payload) {
    commit(types.LOADING_PERFORMANCE_RECORD, true);
    try {
        await postPerformanceRecordAxios(payload);
        commit(types.Add_PERFORMANCE_RECORD, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PERFORMANCE_RECORD, false);
    }
}

export async function updatePerformanceRecordAction({ commit }, payload) {
    commit(types.LOADING_PERFORMANCE_RECORD, true);
    try {
        await putPerformanceRecordAxios(payload);
        commit(types.Update_PERFORMANCE_RECORD, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PERFORMANCE_RECORD, false);
    }
}

export async function removePerformanceRecordAction({ commit }, payload) {
    commit(types.LOADING_PERFORMANCE_RECORD, true);
    try {
        await deletePerformanceRecordAxios(payload);
        commit(types.REMOVE_PERFORMANCE_RECORD, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PERFORMANCE_RECORD, false);
    }
}
